import React from 'react';
import Routes from './routes'
import moment from 'moment';

function App() {

  moment.locale('pt-br');

  return (
      <Routes/>
  );
}

export default App;
